import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import { ROLL_FORWARD_WIZARD_STEPS } from "../../roll_forward_wizard_steps";
import { useRollForwardWizardStore } from "../../roll_forward_wizard_store";

export const WizardActiveStep = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });
  const activeStep = useRollForwardWizardStore((state) => state.activeStep);

  const { titleKey, Component } = ROLL_FORWARD_WIZARD_STEPS[activeStep];

  return (
    <Stack gap="spacingLg">
      <Typography variant="h3">{t(titleKey)}</Typography>
      <Component />
    </Stack>
  );
};
